module.exports = __webpack_public_path__ + "img/avatar.63d5e120.png";